import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-gantt-scale',
    templateUrl: './gantt-scale.component.html',
    styleUrls: ['./gantt-scale.component.scss'],
    standalone: false
})
export class GanttScaleComponent implements OnInit {

  @Input() hours = new Array<number>(24);

  @Input() unit : number;
  
  constructor() { 
    for (let i = 0; i < 24; i += 1) {
      this.hours[i] = i;
    }
  }

  ngOnInit(): void {
  }
  
}
